import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)
import user from "./user"
import register from "./register"
import order from "./order"
import cart from "./cart"

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    register,
    order,
    cart
  }
})
